import React, { useState, useCallback, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import '../../../pages/EmployeeOffboarding/EmployeeOffboarding.css';
import { getAllEmployeesOffBoarded } from '../../../services/EmployeeService';
import PaginationComponent from '../../../components/Pagination/Pagination';
import KeycloakService from '../../../services/KeycloakService';
import { useDispatch } from 'react-redux';
import EmployeeCard from '../../../pages/EmployeeOffboarding/EmployeeCard';
import GenericLoader from '../../../components/Loader/GenericLoader';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { WFHAttribute, SHOW_NOTIFICATION } from '../../../constants';
import DeletableChips from '../../../components/Chip/DeletableChip';
import { getDesignations } from '../../Services/MasterdataService';
const AdminEmployeeOffboarding = (props) => {
  const { selectedStatus, orgEmailData, clearProps } = props;
  const [isAdmin, setIsAdmin] = React.useState(true);
  const [employeeDetails, setEmployeeDetails] = useState({
    applierId: KeycloakService.getUserDetail(),
    tenantId: process.env.REACT_APP_TENANT_ID,
    employeeCode: '',
    firstName: '',
    lastName: '',
    designation: '',
    dateOfBirth: '',
    status: 'PENDING',
    phoneNumber: '',
    personalEmailId: '',
    dateOfJoining: '',
    organizationEmailId: '',
    usageLocation:'',
    jobType: '',
  });
  const [page, setPage] = React.useState(1);
  const [pageNo, setPageNo] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isAdminOffboard, setIsAdminOffboard] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [refreshPage, setRefreshPage] = useState(false);

  const [pageSize, setPageSize] = useState(5);

  const [showErrorMessageDob, setShowErrorMessageDob] = useState(false);
  const [showErrorMessageDoj, setShowErrorMessageDoj] = useState(false);
  const [showErrorMessagePEmail, setShowErrorMessagePEmail] = useState(false);
  const [showErrorMessageOEmail, setShowErrorMessageOEmail] = useState(false);
  const [showErrorMessagePhoneNo, setShowErrorMessagePhoneNo] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);
  const [selected, setSelected] = useState('');
  const [allEmpDetails, setAllEmpDetails] = useState([]);
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [designationNames, setDesignationNames] = useState([]);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    if (selected.length === 0) setIsFocused(false);
  };
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  var designationData;

  const getAllDesignation = async () => {
    designationData = await getDesignations(process.env.REACT_APP_TENANT_ID);

    const newDesignationNames = designationData.data.data.map(
      (data) => data.designationNames[0],
    );
    setDesignationNames(newDesignationNames);
  };

  const getEmployees = async (searchString, pageSize) => {
    if (searchString.length >= 2) {
      setIsLoading(true);
      const employeeList = await getAllEmployeesOffBoarded(
        process.env.REACT_APP_TENANT_ID,
        pageSize,
        pageNo,
        '',
        selectedStatus.value,
        '',
        searchString,
      );
      if (employeeList.isError === false) {
        setAllEmpDetails((prev) => []);
        setAllEmpDetails(employeeList.data.data.content);
        setTotalPage(employeeList.data.data.totalPages);
        if (employeeList?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
        setIsLoading(false);
      }
      dipatchNotification(employeeList.type, employeeList.message);
    } else {
      setIsLoading(false);
    }
  };
  const searchEmployeeByName = useCallback(debounce(getEmployees), []);

  const handleToggle = async (selectedOption) => {
    if (selectedOption === orgEmailData?.status) {
      const employeeListByStatus = await getAllEmployeesOffBoarded(
        process.env.REACT_APP_TENANT_ID,
        pageSize,
        pageNo,
        eName,
        selectedOption,
        orgEmailData.orgEmail,
      );
      dipatchNotification(employeeListByStatus.type, employeeListByStatus.message);
      if (employeeListByStatus?.status === 200) {
        setTotalPage(employeeListByStatus.data.data.totalPages);
        setAllEmpDetails([...employeeListByStatus.data.data.content]);

        if (employeeListByStatus?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
      } else {
        if (employeeListByStatus?.status !== 200) {
          dipatchNotification(
            employeeListByStatus.type,
            employeeListByStatus.message,
          );
        }
        if (
          employeeListByStatus?.status === 200 &&
          !employeeListByStatus.data.data.totalPages
        ) {
          dipatchNotification(
            employeeListByStatus.type,
            'Total Pages Data Not Found',
          );
        }
      }
    } else {
      const employeeListByStatus = await getAllEmployeesOffBoarded(
        process.env.REACT_APP_TENANT_ID,
        pageSize,
        pageNo,
        eName,
        selectedOption,
      );
      dipatchNotification(employeeListByStatus.type, employeeListByStatus.message);
      if (employeeListByStatus?.status === 200) {
        setTotalPage(employeeListByStatus.data.data.totalPages);
        setAllEmpDetails([...employeeListByStatus.data.data.content]);

        if (employeeListByStatus?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
      } else {
        if (employeeListByStatus?.status !== 200) {
          dipatchNotification(
            employeeListByStatus.type,
            employeeListByStatus.message,
          );
        }
        if (
          employeeListByStatus?.status === 200 &&
          !employeeListByStatus.data.data.totalPages
        ) {
          dipatchNotification(
            employeeListByStatus.type,
            'Total Pages Data Not Found',
          );
        }
      }
    }
  };

  let eName = undefined;
  let status = undefined;
  const allEmployeesDetails = async (eName) => {
    setLoader(true);

    try {
      const allEmployees = await getAllEmployeesOffBoarded(
        process.env.REACT_APP_TENANT_ID,
        pageSize,
        pageNo,
        eName,
        status,
      );
      if (!allEmployees.data) {
        setLoader(false);
        return;
      }
      setTotalPage(allEmployees.data.data.totalPages);
      setAllEmpDetails((prevProjects) => [...allEmployees.data.data.content]);
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  const handlePageSizeChange = async (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
  };
  const handleDeleteChip = () => {
    clearProps();
    window.history.pushState(null, '', '/admin-employee-offboarding');
    setRefreshPage(!refreshPage);
  };
  useEffect(() => {
    getEmployees(selected, pageSize);
    if (selected.length <= 1) {
      handleToggle(selectedStatus.value);
    }
  }, [refreshPage, orgEmailData]);

  useEffect(() => {
    getAllDesignation();
  }, []);

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefreshPage(!refreshPage);
  };

  return (
    <div style={{ width: '100%', height: '10%' }}>
      <div style={{ width: '100%', height: '100%' }}>
        {loader ? (
          <div>
            <GenericLoader rectAttributes={WFHAttribute} />
          </div>
        ) : (
          <div>
            <div
              style={{
                display: 'flex',
                paddingBottom: '2rem',
                justifyContent: 'space-between',
                marginRight: '1rem',
                marginLeft: '2rem',
              }}
            >
              <Box width="30%">
                {selectedStatus.value !== orgEmailData.status ? (
                  <TextField
                    className="search-select2"
                    label="Employee Name / ID"
                    name="color"
                    onChange={(e) => {
                      const inputText = e.target.value;
                      if (inputText !== '') {
                        setPage(1);
                        setPageNo(0);
                        searchEmployeeByName(inputText, pageSize);
                        setSelected(inputText);
                      } else {
                        setSelected('');

                        pageChange(null, 1);
                      }
                    }}
                    value={isLastActionFocus ? '' : selected}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    InputLabelProps={
                      !isFocused
                        ? {
                            sx: {
                              transform: 'translate(10%, 25%)',
                            },
                          }
                        : {}
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      sx: {
                        '& input': {
                          height: '5px', // Adjust the height value as needed
                        },
                      },
                    }}
                  />
                ) : null}
                {selectedStatus.value === orgEmailData.status ? (
                  <DeletableChips
                    chipValue={orgEmailData.orgEmail}
                    chipKey={1}
                    deleteChip={handleDeleteChip}
                  />
                ) : null}
              </Box>
            </div>
            {allEmpDetails.length !== 0 ? (
              allEmpDetails.map((employee, index) => (
                <EmployeeCard
                  isAdminOffboard={isAdminOffboard}
                  designationNames={designationNames}
                  key={index}
                  handleToggle={handleToggle}
                  selectedStatus={selectedStatus}
                  allEmployeesDetails={allEmployeesDetails}
                  Files={1}
                  employee={employee}
                  isAdmin={isAdmin}
                  UpdatedEmployeePhoto={employee?.photoPath}
                  EmployeeDetails={employeeDetails}
                  ShowErrorMessageDob={showErrorMessageDob}
                  ShowErrorMessageDoj={showErrorMessageDoj}
                  ShowErrorMessageOEmail={showErrorMessageOEmail}
                  ShowErrorMessagePEmail={showErrorMessagePEmail}
                  ShowErrorMessagePhoneNo={showErrorMessagePhoneNo}
                />
              ))
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                }}
              >
                <div>
                  <Typography>{'No Employee Requests..'}</Typography>
                </div>
              </div>
            )}

            {allEmpDetails.length ? (
              <Box className="page-holder">
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default AdminEmployeeOffboarding;
